/*eslint id-length: ['warn', { exceptions: ['x', '_'] }]*/
angular.module('study.dashboard')
    .component('queriesResolutionTimeReport', {
        templateUrl: 'modules/dashboard/components/queries-resolution-time-report/template.html',
        controller: [
            '$window',
            'gettextCatalog',
            'ShareCrfSDK',
            'ShareCrfApiErrorCodes',
            '$timeout',
            'DashboardUtils',
            function($window, gettextCatalog, ShareCrfSDK, ShareCrfApiErrorCodes, $timeout, DashboardUtils) {
                var vm = this;
                var c3 = $window.c3;
                var _ = $window._;

                var charts = {};
                var chartsData = [];
                var dataByChart = {};

                vm.loading = false;
                vm.error = null;

                vm.$onInit = function () {
                    $timeout(function() {
                        createCharts();
                        loadData();
                    });
                };

                function loadData() {
                    vm.loading = true;

                    return getChartsData().then(function(data) {
                        chartsData = data.sites;

                        dataByChart.closing = createChartData(['closing']);
                        charts.closing.resize({ height: calculateChartHeight(dataByChart.closing.length) });
                        charts.closing.load({
                            json: dataByChart.closing,
                            keys: {
                                x: 'site.code',
                                value: ['closing'],
                            },
                        });
                        var average = roundNumber(data.total.closing);
                        charts.closing.ygrids.add({
                            text: gettextCatalog.getString('Promedio: {{value}}', {
                                value: DashboardUtils.format.decimals(average || 0),
                            }),
                            value: average,
                        });

                        dataByChart.open = createChartData(['sinceOpening.all']);
                        charts.open.resize({ height: calculateChartHeight(dataByChart.open.length) });
                        charts.open.load({
                            json: dataByChart.open,
                            keys: {
                                x: 'site.code',
                                value: ['sinceOpening.all'],
                            },
                        });
                        average = roundNumber(data.total.sinceOpening.all);
                        charts.open.ygrids.add({
                            text: gettextCatalog.getString('Promedio: {{value}}', {
                                value: DashboardUtils.format.decimals(average || 0),
                            }),
                            value: average,
                        });

                        dataByChart.answered = createChartData(['sinceLastAnswer.all']);
                        charts.answered.resize({ height: calculateChartHeight(dataByChart.answered.length) });
                        charts.answered.load({
                            json: dataByChart.answered,
                            keys: {
                                x: 'site.code',
                                value: ['sinceLastAnswer.all'],
                            },
                        });
                        average = roundNumber(data.total.sinceLastAnswer.all);
                        charts.answered.ygrids.add({
                            text: gettextCatalog.getString('Promedio: {{value}}', {
                                value: DashboardUtils.format.decimals(average || 0),
                            }),
                            value: average,
                        });
                    }).catch(function (error) {
                        vm.error = ShareCrfApiErrorCodes.getHumanReadableMessage(error);

                        throw error;
                    }).finally(function () {
                        vm.loading = false;
                    });
                }

                function createCharts() {
                    var commonConfig = {
                        data: {
                            type: 'bar',
                            json: [],
                            empty: {
                                label: {
                                    text: gettextCatalog.getString('No hay datos'),
                                },
                            },
                            labels: {
                                format: function(value) {
                                    return DashboardUtils.format.decimals(value);
                                },
                            },
                        },
                        axis: {
                            rotated: true,
                            x: {
                                type: 'category',
                            },
                            y: {
                                label: {
                                    text: gettextCatalog.getString('# Días'),
                                    position: 'outer-top',
                                },
                            },
                        },
                        bar: {
                            width: 20,
                        },
                        color: {
                            pattern: ['#475b72'],
                        },
                    };

                    var closedConfig = angular.copy(commonConfig);
                    closedConfig.bindto = '#closed-query-by-site';
                    closedConfig.data.columns = ['closing'];
                    closedConfig.data.names = {
                        closing: gettextCatalog.getString('# Días'),
                    };
                    closedConfig.tooltip = {
                        contents: function(data) {
                            var row = dataByChart.closing[data[0].index];

                            return DashboardUtils.tooltip({
                                header: '[' + row.site.code + '] ' + row.site.name,
                                rows: [
                                    {
                                        key: 'rate',
                                        label: gettextCatalog.getString('# Días'),
                                        value: row.closing,
                                        format: 'decimals',
                                        color: commonConfig.color.pattern[0],
                                    },
                                    {
                                        key: 'queries',
                                        label: gettextCatalog.getString('# Queries cerradas'),
                                        value: row.count.closed,
                                    },
                                ],
                            });
                        },
                    };

                    charts.closing = c3.generate(closedConfig);

                    var openConfig = angular.copy(commonConfig);
                    openConfig.bindto = '#time-elapsed-open-queries';
                    openConfig.data.columns = ['sinceOpening.all'];
                    openConfig.data.names = {
                        'sinceOpening.all': gettextCatalog.getString('# Días'),
                    };
                    openConfig.tooltip = {
                        contents: function(data) {
                            var row = dataByChart.open[data[0].index];

                            return DashboardUtils.tooltip({
                                header: '[' + row.site.code + '] ' + row.site.name,
                                rows: [
                                    {
                                        key: 'rateall',
                                        label: gettextCatalog.getString('# Días desde apertura'),
                                        value: row.sinceOpening.all,
                                        format: 'decimals',
                                        color: commonConfig.color.pattern[0],
                                    },
                                    {
                                        key: 'queriesall',
                                        label: gettextCatalog.getString('# Queries abiertas'),
                                        value: row.count.open,
                                    },
                                    {
                                        key: 'ratenonanswered',
                                        label: gettextCatalog.getString('# Días desde apertura sin respuesta'),
                                        value: row.sinceOpening.nonAnswered,
                                        format: 'decimals',
                                    },
                                    {
                                        key: 'queriesnonanswered',
                                        label: gettextCatalog.getString('# Queries abiertas sin respuesta'),
                                        value: row.count.nonAnswered,
                                    },
                                    {
                                        key: 'rateanswered',
                                        label: gettextCatalog.getString('# Días desde apertura con respuesta'),
                                        value: row.sinceOpening.answered,
                                        format: 'decimals',
                                    },
                                    {
                                        key: 'queriesanswered',
                                        label: gettextCatalog.getString('# Queries abiertas con respuesta'),
                                        value: row.count.answered,
                                    },
                                ],
                            });
                        },
                    };

                    charts.open = c3.generate(openConfig);

                    var answeredConfig = angular.copy(commonConfig);
                    answeredConfig.bindto = '#time-elapsed-open-since-last-answer';
                    answeredConfig.data.columns = ['sinceLastAnswer.all'];
                    answeredConfig.data.names = {
                        'sinceLastAnswer.all': gettextCatalog.getString('# Días'),
                    };
                    answeredConfig.tooltip = {
                        contents: function(data) {
                            var row = dataByChart.answered[data[0].index];

                            return DashboardUtils.tooltip({
                                header: '[' + row.site.code + '] ' + row.site.name,
                                rows: [
                                    {
                                        key: 'rateall',
                                        label: gettextCatalog.getString('# Días desde última respuesta'),
                                        value: row.sinceLastAnswer.all,
                                        format: 'decimals',
                                        color: commonConfig.color.pattern[0],
                                    },
                                    {
                                        key: 'queriesall',
                                        label: gettextCatalog.getString('# Queries con respuesta'),
                                        value: row.count.updated,
                                    },
                                    {
                                        key: 'rateinsite',
                                        label: gettextCatalog.getString('# Días desde última respuesta en el mismo centro'),
                                        value: row.sinceLastAnswer.inSite,
                                        format: 'decimals',
                                    },
                                    {
                                        key: 'queriesinsite',
                                        label: gettextCatalog.getString('# Queries con respuesta en el mismo centro'),
                                        value: row.count.inSite,
                                    },
                                    {
                                        key: 'rateoffsite',
                                        label: gettextCatalog.getString('# Días desde última respuesta fuera del mismo centro'),
                                        value: row.sinceLastAnswer.offSite,
                                        format: 'decimals',
                                    },
                                    {
                                        key: 'queriesoffsite',
                                        label: gettextCatalog.getString('# Queries con respuesta fuera del mismo centro'),
                                        value: row.count.offSite,
                                    },
                                ],
                            });
                        },
                    };

                    charts.answered = c3.generate(answeredConfig);
                }

                function getChartsData() {
                    return ShareCrfSDK.dashboard.queriesResolutionTimeDetail();
                }

                function createChartData(columns) {
                    return chartsData.reduce(function(acc, row) {
                        // Primero se eliminan las líneas vacías
                        if (columns.some(function(column) {
                            return _.get(row, column, 0) > 0;
                        })) {
                            // A continuación se normalizan los números a los mismos decimales
                            angular.forEach(columns, function(column) {
                                var currentValue = _.get(row, column, null);
                                if (currentValue !== null) {
                                    _.set(row, column, roundNumber(currentValue));
                                }
                            });
                            acc.push(row);
                        }

                        return acc;
                    }, []);
                }

                function roundNumber(value) {
                    return value !== null ? _.toNumber(value.toFixed(2)) : 0;
                }

                function calculateChartHeight(numberOfRows) {
                    var rowHeight = 36; // px per row
                    var offsetLegend = 114;
                    var minHeight = rowHeight + offsetLegend; // at least one row height

                    return Math.max(minHeight, numberOfRows * rowHeight + offsetLegend);
                }
            },
        ],
    });